import { Component, ElementRef } from '@angular/core';
import { IWizItemRenderer, WizBaseCollector } from '@wizeoo/akm-component-lib';
import { VisionKeyObj } from '../../../vo/vision/tools/visionkey.obj';

@Component({
  selector: 'vision-key-renderer',
  template: `
    <wiz-hgroup width="100%" height="100%" verticalAlign="center" style="padding-left:5px; padding-right:5px">
      <wiz-label [wizLabel]="data.label" width="100%"></wiz-label>
      <wiz-icon *ngIf="data.isChronocode">chronocodes</wiz-icon>
    </wiz-hgroup>
  `,
})
export class VisionKeyRenderer implements IWizItemRenderer<null, VisionKeyObj> {
  constructor(public elementRef: ElementRef) {}

  data: VisionKeyObj;
  owner: WizBaseCollector;
}
